import { BASE_URL } from "../constants/Endpoints"
import axios from "axios";

export class ReportingService {
    base(path) { return `${BASE_URL}/${path}` }

    async getAgentRevenueReport(params = {}) {
        const url = this.base(`reporting/agent-revenue`);
        return await axios.get(url, { params }).then(r => r.data);
    }

    async getAgentActivityReport() {
        const url = this.base(`reporting/agent-activity`);
        return await axios.get(url).then(r => r.data);
    }

    async getPromemoriaContacts(params = {}) {
        const url = this.base(`reporting/promemoria`);
        return await axios.get(url, { params }).then(r => r.data);
    }
}
